module.exports = __webpack_public_path__ + "img/IMG_1539_L_BlackMatted.dd68bb9c.jpg";